module.exports = __webpack_public_path__ + "img/switzerland-neoplasm-female.5a448fa0.png";